/**
 * cancelReason：不同端需要去各自的transify配置多语言，admin直接读取原因的admin字段即可
 * 1-200 废弃
 * 10000+ 新code
 *
 * index 排序权重 默认值为 1
 * admin: enable:true: admin 端取消订单可选原因  false:不可选
 * driver: enable: true false：不可选; driver端排序已用 index包括[-4,-3,-2,-1,0,1,2,3]，默认为0
 * buyer: enable:true: admin 端取消订单可选原因  false:不可选
 * merchant: enable: true false：不可选
 *
 * classify: 分类 - driver 端会将原因分类后使用
 */

export const DRIVER_REASON = 'driver'; // 骑手原因
export const RESTAURANT_REASON = 'restaurant'; // 寄件方原因
export const CUSTOMER_REASON = 'customer'; // 包裹原因
export const OTHER_REASON = 'other'; // 其他原因

export const cancelReason = {
  // old
  '1': {
    admin: { enable: false, text: 'Customer did not receive order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.1' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.not_received' },
    merchant: { enable: false, key: 'order.cancel_reason.1' },
  },
  '2': {
    admin: { enable: false, text: 'Customer placed wrong order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.2' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.wrong_order' },
    merchant: { enable: false, key: 'order.cancel_reason.2' },
  },
  '3': {
    admin: { enable: false, text: 'Customer wanted to change payment method' },
    driver: { enable: false, key: 'order.cancel.reason.driver.3' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.change_payment' },
    merchant: { enable: false, key: 'order.cancel_reason.3' },
  },
  '4': {
    admin: { enable: false, text: 'Customer has changed the plan' },
    driver: { enable: false, key: 'order.cancel.reason.driver.4' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.change_plan' },
    merchant: { enable: false, key: 'order.cancel_reason.4' },
  },
  '5': {
    admin: { enable: false, text: 'Customer wanted to cancel order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.5' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.NoReason' },
    merchant: { enable: false, key: 'order.cancel_reason.5' },
  },
  '6': {
    admin: { enable: false, text: 'Driver reported customer asked to cancel' },
    driver: { enable: false, key: 'order.cancel.reason.driver.6' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.buyer_request_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.6' },
  },
  '7': {
    admin: { enable: false, text: 'Customer input wrong address / phone' },
    driver: { enable: false, key: 'order.cancel.reason.driver.7' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.wrong_address' },
    merchant: { enable: false, key: 'order.cancel_reason.7' },
  },
  '8': {
    admin: { enable: false, text: 'Customer forgot to use voucher' },
    driver: { enable: false, key: 'order.cancel.reason.driver.8' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.forget_voucher' },
    merchant: { enable: false, key: 'order.cancel_reason.8' },
  },
  '9': {
    admin: {
      enable: false,
      text: 'Driver reported customer wanted to cancel due to price changed',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.9' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.price_changed' },
    merchant: { enable: false, key: 'order.cancel_reason.9' },
  },
  '10': {
    admin: { enable: false, text: 'Driver reported customer is uncontactable' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.lost_contact' },
    merchant: { enable: false, key: 'order.cancel_reason.10' },
  },
  '11': {
    admin: { enable: false, text: 'Driver reported fake order of customer' },
    driver: { enable: false, key: 'order.cancel.reason.driver.11' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.fake_order' },
    merchant: { enable: false, key: 'order.cancel_reason.11' },
  },
  '12': {
    admin: { enable: false, text: 'Driver asked customer to cancel' },
    driver: { enable: false, key: 'order.cancel.reason.driver.12' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_request_buyer',
    },
    merchant: { enable: false, key: 'order.cancel_reason.12' },
  },
  '13': {
    admin: { enable: false, text: 'Customer cannot contact driver' },
    driver: { enable: false, key: 'order.cancel.reason.driver.13' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.lost_driver_contact',
    },
    merchant: { enable: false, key: 'order.cancel_reason.13' },
  },
  '14': {
    admin: { enable: false, text: "Driver doesn't have enough money" },
    driver: { enable: false, key: 'order.cancel.reason.driver.106' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_lack_money',
    },
    merchant: { enable: false, key: 'order.cancel_reason.14' },
  },
  '15': {
    admin: { enable: false, text: 'Driver is too far' },
    driver: { enable: false, key: 'order.cancel.reason.driver.15' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.driver_too_far' },
    merchant: { enable: false, key: 'order.cancel_reason.15' },
  },
  '16': {
    admin: { enable: false, text: 'Customer has waited too long' },
    driver: { enable: false, key: 'order.cancel.reason.driver.16' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.wait_too_long' },
    merchant: { enable: false, key: 'order.cancel_reason.16' },
  },
  '17': {
    admin: { enable: false, text: 'Out of stock' },
    driver: { enable: false, key: 'order.cancel.reason.driver.17' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.out_of_stock',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10017' },
  },
  '18': {
    admin: { enable: false, text: 'Customer did not agree with edited order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10018' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.not_agree_with_edited',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10018' },
  },
  '19': {
    admin: { enable: false, text: 'Store was closed' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10019' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.store_closed',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10019' },
  },
  '20': {
    admin: { enable: false, text: 'Customer wants to edit order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10020' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.want_to_edit_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10020' },
  },
  '21': {
    admin: { enable: false, text: 'Customer regrets after submit' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10021' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.regret_after_submit',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10021' },
  },
  '50': {
    admin: { enable: false, text: 'Others' },
    driver: { enable: false, key: 'order.cancel.reason.driver.50' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.others' },
    merchant: { enable: false, key: 'order.cancel_reason.50' },
  },
  '51': {
    admin: { enable: false, text: 'Out of stock' },
    driver: { enable: false, key: 'order.cancel.reason.driver.17' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.out_of_stock',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10017' },
  },
  '52': {
    admin: { enable: false, text: 'Store was busy' },
    driver: { enable: false, key: 'order.cancel.reason.driver.52' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.store_busy' },
    merchant: { enable: false, key: 'order.cancel_reason.52' },
  },
  '53': {
    admin: { enable: false, text: 'Store was closed' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10019' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.store_closed',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10019' },
  },
  '54': {
    admin: { enable: false, text: 'Merchant missed order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.54' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.missed_order' },
    merchant: { enable: false, key: 'order.cancel_reason.54' },
  },
  '55': {
    admin: {
      enable: false,
      text: 'Restaurant rejects the order',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.55' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.restaurant_rejects_the_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10113' },
  },
  '57': {
    admin: {
      enable: false,
      text: 'Merchant reported that driver is unresponsive',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.10057' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.merchant_report_driver_unresponsive',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10057' },
  },
  '58': {
    admin: {
      enable: false,
      text: 'Merchant reported that driver asked to cancel',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.10058' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.merchant_report_driver_aske_to_cancel',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10058' },
  },
  '100': {
    admin: { enable: false, text: 'Others' },
    driver: { enable: false, key: 'order.cancel.reason.driver.50' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.others' },
    merchant: { enable: false, key: 'order.cancel_reason.50' },
  },
  '101': {
    admin: { enable: false, text: 'Late delivery' },
    driver: { enable: false, key: 'order.cancel.reason.driver.101' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.late_delivery' },
    merchant: { enable: false, key: 'order.cancel_reason.101' },
  },
  '102': {
    admin: { enable: false, text: 'Driver could not continue to deliver' },
    driver: { enable: false, key: 'order.cancel.reason.driver.102' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.can_not_deliver' },
    merchant: { enable: false, key: 'order.cancel_reason.102' },
  },
  '103': {
    admin: { enable: false, text: 'Driver could not find merchant' },
    driver: { enable: false, key: 'order.cancel.reason.driver.103' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_restaurant',
    },
    merchant: { enable: false, key: 'order.cancel_reason.103' },
  },
  '104': {
    admin: { enable: false, text: 'Driver could not find customer' },
    driver: { enable: false, key: 'order.cancel.reason.driver.104' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_buyer',
    },
    merchant: { enable: false, key: 'order.cancel_reason.104' },
  },
  '105': {
    admin: { enable: false, text: 'Low delivery quality' },
    driver: { enable: false, key: 'order.cancel.reason.driver.105' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.low_delivery_quality',
    },
    merchant: { enable: false, key: 'order.cancel_reason.105' },
  },
  '106': {
    admin: { enable: false, text: "Driver doesn't have enough money" },
    driver: {
      enable: true,
      key: 'order.cancel.reason.driver.106',
      index: -1,
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_lack_money',
    },
    merchant: { enable: false, key: 'order.cancel_reason.14' },
  },
  '107': {
    admin: { enable: false, text: 'Driver accidentally took the order' },
    driver: {
      enable: true,
      key: 'order.cancel.reason.driver.107',
      index: -4,
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.accidentally_take',
    },
    merchant: { enable: false, key: 'order.cancel_reason.107' },
  },
  '108': {
    admin: { enable: false, text: "Driver's vehicle is broken" },
    driver: { enable: false, key: 'order.cancel.reason.driver.108' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.broken_vehicle' },
    merchant: { enable: false, key: 'order.cancel_reason.108' },
  },
  '109': {
    admin: {
      enable: false,
      text: 'Customer did not agree with edited order',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.10018' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.not_agree_with_edited',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10018' },
  },
  '110': {
    admin: { enable: false, text: 'Out of stock' },
    driver: { enable: false, key: 'order.cancel.reason.driver.17' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.out_of_stock',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10017' },
  },
  '111': {
    admin: { enable: false, text: 'Driver reported customer asked to cancel' },
    driver: { enable: false, key: 'order.cancel.reason.driver.111' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.buyer_request_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.111' },
  },
  '112': {
    admin: { enable: false, text: 'Store was closed' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10019' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.store_closed',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10019' },
  },
  '113': {
    admin: {
      enable: false,
      text: 'Restaurant rejects the order',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.55' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.restaurant_rejects_the_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10113' },
  },
  '114': {
    admin: { enable: false, text: 'Driver reported fake order of customer' },
    driver: { enable: false, key: 'order.cancel.reason.driver.114' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_report_fake_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.114' },
  },
  '115': {
    admin: {
      enable: false,
      text: "Driver's vehicle is broken on the way to merchant",
    },
    driver: {
      enable: false,
      key: 'order.cancel.reason.driver.10115',
    },
    buyer: {
      enable: false,
      key:
        'order_detail.cancel_reason.driver_vehicle_broken_on_way_to_merchant',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10115' },
  },
  '116': {
    admin: {
      enable: false,
      text: "Driver's vehicle is broken on the way to customer",
    },
    driver: {
      enable: false,
      key: 'order.cancel.reason.driver.10116',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_vehicle_broken_on_way_to_buyer',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10116' },
  },
  '150': {
    admin: { enable: false, text: 'Others' },
    driver: { enable: false, key: 'order.cancel.reason.driver.50' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.others' },
    merchant: { enable: false, key: 'order.cancel_reason.50' },
  },
  '151': {
    admin: { enable: false, text: 'Cannot match driver' },
    driver: { enable: false, key: 'order.cancel.reason.driver.151' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10151' },
  },
  '152': {
    admin: { enable: false, text: 'Payment failed' },
    driver: { enable: false, key: 'order.cancel.reason.driver.152' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.payment_failed' },
    merchant: { enable: false, key: 'order.cancel_reason.152' },
  },
  '153': {
    admin: { enable: false, text: 'Payment timeout' },
    driver: { enable: false, key: 'order.cancel.reason.driver.153' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.expired' },
    merchant: { enable: false, key: 'order.cancel_reason.153' },
  },
  '155': {
    admin: { enable: false, text: 'Low completion rate predicted' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10155' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10155' },
  },
  '156': {
    admin: { enable: false, text: 'Admin closed and algo re-assigned' },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10156' },
    buyer: {
      enable: false,
      // buyer 端无感，不需要展示
      key: '',
    },
    merchant: { enabled: false, key: 'order.cancel_reason.10156' },
  },

  // new
  '10001': {
    admin: { enable: false, text: 'Customer did not receive order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.1' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.not_received' },
    merchant: { enable: false, key: 'order.cancel_reason.1' },
  },
  '10002': {
    admin: { enable: false, text: 'Customer placed wrong order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.2' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.wrong_order' },
    merchant: { enable: false, key: 'order.cancel_reason.2' },
  },
  '10003': {
    admin: { enable: true, text: 'Customer wanted to change payment method' },
    driver: { enable: false, key: 'order.cancel.reason.driver.3' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.change_payment' },
    merchant: { enable: false, key: 'order.cancel_reason.3' },
  },
  '10004': {
    admin: { enable: true, text: 'Customer has changed the plan' },
    driver: { enable: false, key: 'order.cancel.reason.driver.4' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.change_plan' },
    merchant: { enable: false, key: 'order.cancel_reason.4' },
  },
  '10005': {
    admin: { enable: false, text: 'Customer wanted to cancel order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.5' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.NoReason' },
    merchant: { enable: false, key: 'order.cancel_reason.5' },
  },
  '10006': {
    admin: { enable: false, text: 'Driver reported customer asked to cancel' },
    driver: { enable: false, key: 'order.cancel.reason.driver.6' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.buyer_request_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.6' },
  },
  '10007': {
    admin: { enable: true, text: 'Customer input wrong address / phone' },
    driver: { enable: false, key: 'order.cancel.reason.driver.7' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.wrong_address' },
    merchant: { enable: false, key: 'order.cancel_reason.7' },
  },
  '10008': {
    admin: { enable: true, text: 'Customer forgot to use voucher' },
    driver: { enable: false, key: 'order.cancel.reason.driver.8' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.forget_voucher' },
    merchant: { enable: false, key: 'order.cancel_reason.8' },
  },
  '10009': {
    admin: {
      enable: false,
      text: 'Driver reported customer wanted to cancel due to price changed',
    },
    driver: {
      enable: false,
      key: 'order.cancel.reason.driver.9',
    },
    buyer: { enable: false, key: 'order_detail.cancel_reason.price_changed' },
    merchant: { enable: false, key: 'order.cancel_reason.9' },
  },
  '10010': {
    admin: { enable: false, text: 'Driver reported customer is uncontactable' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.lost_contact' },
    merchant: { enable: false, key: 'order.cancel_reason.10' },
  },
  '10011': {
    admin: { enable: false, text: 'Driver reported fake order of customer' },
    driver: { enable: false, key: 'order.cancel.reason.driver.11' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.fake_order' },
    merchant: { enable: false, key: 'order.cancel_reason.11' },
  },
  '10012': {
    admin: { enable: true, text: 'Driver asked customer to cancel' },
    driver: { enable: false, key: 'order.cancel.reason.driver.12' },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.driver_request_buyer',
    },
    merchant: { enable: false, key: 'order.cancel_reason.12' },
  },
  '10013': {
    admin: { enable: true, text: 'Customer cannot contact driver' },
    driver: { enable: false, key: 'order.cancel.reason.driver.13' },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.lost_driver_contact',
    },
    merchant: { enable: false, key: 'order.cancel_reason.13' },
  },
  '10014': {
    admin: { enable: true, text: "Driver doesn't have enough money" },
    driver: {
      index: 3,
      enable: true,
      classify: DRIVER_REASON,
      key: 'order.cancel.reason.driver.106',
    },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.driver_lack_money',
    },
    merchant: { enable: false, key: 'order.cancel_reason.14' },
  },
  '10015': {
    admin: { enable: true, text: 'Driver is too far' },
    driver: { enable: false, key: 'order.cancel.reason.driver.15' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.driver_too_far' },
    merchant: { enable: false, key: 'order.cancel_reason.15' },
  },
  '10016': {
    admin: { enable: true, text: 'Customer has waited too long' },
    driver: { enable: false, key: 'order.cancel.reason.driver.16' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.wait_too_long' },
    merchant: { enable: false, key: 'order.cancel_reason.16' },
  },
  '10017': {
    admin: { enable: true, text: 'Item(s) is out of stock' },
    driver: {
      index: 8,
      classify: RESTAURANT_REASON,
      enable: true,
      key: 'order.cancel.reason.driver.17',
    },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.out_of_stock',
    },
    merchant: { enable: true, key: 'order.cancel_reason.10017' },
  },
  '10018': {
    admin: { enable: true, text: 'Customer did not agree with edited order' },
    driver: {
      index: 11,
      classify: CUSTOMER_REASON,
      enable: true,
      key: 'order.cancel.reason.driver.10018',
    },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.not_agree_with_edited',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10018' },
  },
  '10019': {
    admin: { enable: true, text: 'Store was closed' },
    driver: {
      index: 7,
      classify: RESTAURANT_REASON,
      enable: true,
      key: 'order.cancel.reason.driver.10019',
    },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.store_closed',
    },
    merchant: { enable: true, key: 'order.cancel_reason.10019' },
  },
  '10020': {
    admin: { enable: true, text: 'Customer wants to edit order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10020' },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.want_to_edit_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10020' },
  },
  '10021': {
    admin: { enable: true, text: 'Customer regrets after submit' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10021' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.regret_after_submit',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10021' },
  },
  '10052': {
    admin: { enable: true, text: 'Store is busy/not ready' },
    driver: { enable: false, key: 'order.cancel.reason.driver.52' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.store_busy' },
    merchant: { enable: true, key: 'order.cancel_reason.52' },
  },
  '10054': {
    admin: { enable: false, text: 'Merchant missed order' },
    driver: { enable: false, key: 'order.cancel.reason.driver.54' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.missed_order' },
    merchant: { enable: false, key: 'order.cancel_reason.54' },
  },
  '10057': {
    admin: {
      enable: true,
      text: 'Merchant reported that driver is unresponsive',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.10057' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.merchant_report_driver_unresponsive',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10057' },
  },
  '10058': {
    admin: {
      enable: true,
      text: 'Merchant reported that driver asked to cancel',
    },
    driver: { enable: false, key: 'order.cancel.reason.driver.10058' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.merchant_report_driver_aske_to_cancel',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10058' },
  },
  '10101': {
    admin: { enable: false, text: 'Late delivery' },
    driver: { enable: false, key: 'order.cancel.reason.driver.101' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.late_delivery' },
    merchant: { enable: false, key: 'order.cancel_reason.101' },
  },
  '10102': {
    admin: { enable: false, text: 'Driver could not continue to deliver' },
    driver: { enable: false, key: 'order.cancel.reason.driver.102' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.can_not_deliver' },
    merchant: { enable: false, key: 'order.cancel_reason.102' },
  },
  '10103': {
    admin: { enable: true, text: 'Driver could not find merchant' },
    driver: {
      index: 6,
      classify: RESTAURANT_REASON,
      enable: true,
      key: 'order.cancel.reason.driver.103',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_restaurant',
    },
    merchant: { enable: false, key: 'order.cancel_reason.103' },
  },
  '10104': {
    admin: { enable: true, text: 'Driver could not find customer' },
    driver: {
      index: 13,
      enable: true,
      classify: CUSTOMER_REASON,
      key: 'order.cancel.reason.driver.104',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_buyer',
    },
    merchant: { enable: false, key: 'order.cancel_reason.104' },
  },
  '10105': {
    admin: { enable: false, text: 'Low delivery quality' },
    driver: { enable: false, key: 'order.cancel.reason.driver.105' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.low_delivery_quality',
    },
    merchant: { enable: false, key: 'order.cancel_reason.105' },
  },
  '10107': {
    admin: { enable: true, text: 'Driver accidentally took the order' },
    driver: {
      index: 4,
      enable: true,
      classify: DRIVER_REASON,
      key: 'order.cancel.reason.driver.107',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.accidentally_take',
    },
    merchant: { enable: false, key: 'order.cancel_reason.107' },
  },
  '10108': {
    admin: { enable: false, text: "Driver's vehicle is broken" },
    driver: { enable: false, key: 'order.cancel.reason.driver.108' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.broken_vehicle' },
    merchant: { enable: false, key: 'order.cancel_reason.108' },
  },
  '10111': {
    admin: { enable: true, text: 'Driver reported customer asked to cancel' },
    driver: {
      index: 12,
      classify: CUSTOMER_REASON,
      enable: true,
      key: 'order.cancel.reason.driver.111',
      countries: ['id', 'my'],
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.buyer_request_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.111' },
  },
  '10113': {
    admin: {
      enable: true,
      text: 'Restaurant rejects the order',
    },
    driver: {
      index: 9,
      enable: true,
      classify: RESTAURANT_REASON,
      key: 'order.cancel.reason.driver.55',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.restaurant_rejects_the_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10113' },
  },
  '10114': {
    admin: { enable: true, text: 'Driver reported fake order of customer' },
    driver: {
      index: 14,
      enable: true,
      classify: CUSTOMER_REASON,
      key: 'order.cancel.reason.driver.114',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_report_fake_order',
    },
    merchant: { enable: false, key: 'order.cancel_reason.114' },
  },
  '10115': {
    admin: {
      enable: true,
      text: "Driver's vehicle is broken on the way to merchant",
    },
    driver: {
      enable: true,
      classify: DRIVER_REASON,
      key: 'order.cancel.reason.driver.10115',
      index: 1,
    },
    buyer: {
      enable: false,
      key:
        'order_detail.cancel_reason.driver_vehicle_broken_on_way_to_merchant',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10115' },
  },
  '10116': {
    admin: {
      enable: true,
      text: "Driver's vehicle is broken on the way to customer",
    },
    driver: {
      index: 2,
      enable: true,
      classify: DRIVER_REASON,
      key: 'order.cancel.reason.driver.10116',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_vehicle_broken_on_way_to_buyer',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10116' },
  },
  '10151': {
    admin: { enable: true, text: 'Cannot match driver' },
    driver: { enable: false, key: 'order.cancel.reason.driver.151' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10151' },
  },
  '10152': {
    admin: { enable: true, text: 'Payment failed' },
    driver: { enable: false, key: 'order.cancel.reason.driver.152' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.payment_failed' },
    merchant: { enable: false, key: 'order.cancel_reason.152' },
  },
  '10153': {
    admin: { enable: false, text: 'Payment timeout' },
    driver: { enable: false, key: 'order.cancel.reason.driver.153' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.expired' },
    merchant: { enable: false, key: 'order.cancel_reason.153' },
  },
  '10155': {
    admin: { enable: false, text: 'Low completion rate predicted' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10155' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.can_not_find_driver',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10155' },
  },
  '10156': {
    admin: { enable: false, text: 'Admin closed and algo re-assigned' },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10156' },
    buyer: {
      enable: false,
      // buyer 端无感，不需要展示
      key: '',
    },
    merchant: { enabled: false, key: 'order.cancel_reason.10156' },
  },
  '10050': {
    admin: { enable: true, text: 'Others', index: 9999 },
    driver: {
      index: 15,
      enable: true,
      classify: OTHER_REASON,
      key: 'order.cancel.reason.driver.50',
    },
    buyer: {
      enable: true,
      key: 'order_detail.cancel_reason.others',
      index: 9999,
    },
    merchant: { enable: true, key: 'order.cancel_reason.50', index: 9999 },
  },
  '10117': {
    admin: {
      enable: true,
      text: 'Driver reported long queue in the restaurant',
    },
    driver: {
      index: 10,
      enable: true,
      classify: RESTAURANT_REASON,
      key: 'order.cancel.reason.driver.10117',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.long_queue',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10117' },
  },
  '10118': {
    admin: {
      enable: true,
      text: 'Driver reported bad weather',
    },
    driver: {
      index: 5,
      enable: true,
      classify: DRIVER_REASON,
      key: 'order.cancel.reason.driver.10118',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.bad_weather',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10118' },
  },
  '10160': {
    admin: {
      enable: true,
      text: 'System/Application is not responding',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10160' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.not_responding',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10160' },
  },
  '10161': {
    admin: {
      enable: true,
      text: 'Driver reports that merchant is unresponsive',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10161' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.merchant_unresponsive',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10161' },
  },
  '10162': {
    admin: {
      enable: true,
      text: 'Driver does not pick up Food',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10162' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.driver_not_pick',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10162' },
  },
  '10163': {
    admin: {
      enable: true,
      text: 'Restaurant has not started operating with ShopeeFood',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10163' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.restaurant_not_start',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10163' },
  },
  '10164': {
    admin: {
      enable: true,
      text: 'Food is not ready for pick-up when driver arrived',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10164' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.order_delay',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10164' },
  },
  '10165': {
    admin: {
      enable: true,
      text: 'Actual price is not the same as listed price',
    },
    driver: {
      index: 11,
      enable: true,
      classify: RESTAURANT_REASON,
      key: 'order.cancel.reason.driver.10165',
      countries: ['th', 'my'],
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.price_not_same',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10165' },
  },
  '10166': {
    admin: {
      enable: true,
      text: 'Customer address is not found',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10166' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.address_not_found',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10166' },
  },
  '10167': {
    admin: {
      enable: true,
      text: "Customer doesn't accept the order",
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10167' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.not_accept',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10167' },
  },
  '10168': {
    admin: {
      enable: true,
      text: 'Improper food handling by driver',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10168' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.improper_food',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10168' },
  },
  '10169': {
    admin: {
      enable: true,
      text: `Buyer's incorrect pin location`,
    },
    buyer: {
      enable: false,
      key: '',
    },
    web: { enable: false, text: `Customer's incorrect pin location` },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10169' },
    merchant: { enable: false, key: 'order.cancel_reason.10169' },
  },
  '10170': {
    admin: {
      enable: true,
      text: 'Order is too big',
    },
    buyer: {
      enable: false,
      key: '',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10170' },
    merchant: { enable: false, key: 'order.cancel_reason.10170' },
  },
  '10171': {
    admin: {
      enable: true,
      text: 'Orders have been switched',
    },
    buyer: {
      enable: false,
      key: '',
    },
    web: { enable: false, text: `Delivery incorrect order` },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10171' },
    merchant: { enable: false, key: 'order.cancel_reason.10171' },
  },
  '10172': {
    admin: {
      enable: true,
      text: 'Driver has waited too long in the restaurant',
    },
    buyer: {
      enable: false,
      key: '',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10172' },
    merchant: { enable: false, key: 'order.cancel_reason.10172' },
  },
  '10173': {
    admin: {
      enable: true,
      text: 'Store is closing soon',
    },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.store_closing_soon',
    },
    merchant: { enable: true, key: 'order.cancel_reason.10173' },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10173' },
  },
  '10174': {
    admin: {
      enable: false,
      text: 'Driver reports that restaurant is too far',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10174' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.restaurant_too_far',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10174' },
  },
  '10175': {
    admin: {
      enable: false,
      text: 'Driver reports that customer location is too far',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10175' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.customer_location_too_far',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10175' },
  },
  '10176': {
    admin: {
      enable: false,
      text: 'Exceed Re-assign limit',
    },
    merchant: { enable: false, key: 'order.cancel_reason.10176' },
    buyer: {
      enable: false,
      key: 'order_detail.cancel_reason.exceed_reassign_limit',
    },
    driver: { enabled: false, key: 'order.cancel.reason.driver.10176' },
  },
  '10177': {
    admin: { enable: true, text: 'Customer ordered wrong order type' },
    merchant: { enable: false, key: 'order.cancel_reason.10177' },
    buyer: { enable: true, key: 'order_detail.cancel_reason.wrong_order_type' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10177' },
  },
  '10178': {
    admin: { enable: true, text: 'Customer could not find merchant' },
    merchant: { enable: false, key: 'order.cancel_reason.10178' },
    buyer: { enable: false, key: 'order_detail.cancel_reason.can_not_find_merchant' },
    driver: { enable: false, key: 'order.cancel.reason.driver.10178' },
  },
};

export const editReason = {
  '201': {
    admin: 'Some selected dishes are not available',
    driver: { enable: true, key: 'order.edit.reason.driver.201' },
    merchant: 'order.edit_reason.201',
  },
  '202': {
    admin: 'Customer asked to add/remove order',
    driver: { enable: true, key: 'order.edit.reason.driver.202' },
    merchant: 'order.edit_reason.202',
  },
  '203': {
    admin: "Merchant's price list has not been updated",
    driver: { enable: true, key: 'order.edit.reason.driver.203' },
    merchant: 'order.edit_reason.203',
  },
  '204': {
    admin: 'Additional fee from merchant',
    driver: { enable: true, key: 'order.edit.reason.driver.204' },
    merchant: 'order.edit_reason.204',
  },
  '250': {
    admin: 'Others',
    driver: { enable: true, key: 'order.edit.reason.driver.250' },
    merchant: 'order.edit_reason.250',
  },
};

/**
 * returnReason
 * 301-350: buyer责任
 * 351-400: driver责任
 * 401-450: merchant责任
 * 451-500: platform问题
 */

export const returnReason = {
  '301': {
    admin: 'Customer personal opinion',
    merchant: 'order.return_reason.301',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.customer_personal_opinion',
    },
  },
  '302': {
    admin: 'Customer wrong order',
    merchant: 'order.return_reason.302',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.customer_wrong_order',
    },
  },
  '303': {
    admin: 'Others',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.others',
      index: -1,
    },
  },
  '351': {
    admin: 'Driver complete order without delivering',
    merchant: 'order.return_reason.351',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.no_items_received',
      index: 2,
    },
  },
  '352': {
    admin: 'Driver is uncontactable',
    merchant: 'order.return_reason.352',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.driver_uncontactable',
      index: 4,
    },
  },
  '353': {
    admin: 'Improper Food Handling',
    merchant: 'order.return_reason.353',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.improper_food_handing',
    },
  },
  '354': {
    admin: 'Food seal broken',
    merchant: 'order.return_reason.354',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.food_seal_broken',
      index: 1,
    },
  },
  '355': {
    admin: 'Accident',
    merchant: 'order.return_reason.355',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.accident',
    },
  },
  '356': {
    admin: 'Driver asked for more payment without informing user',
    merchant: 'order.return_reason.356',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.without_informing_user',
    },
  },
  '357': {
    admin: 'Driver input wrong amount',
    merchant: 'order.return_reason.357',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.driver_input_wrong_amount',
    },
  },
  '358': {
    admin: 'Driver takes too long',
    merchant: 'order.return_reason.358',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.driver_takes_too_long',
    },
  },
  '359': {
    admin: 'Customer paid twice',
    merchant: 'order.return_reason.359',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.customer_paid_twice',
    },
  },
  '360': {
    admin: "Driver didn't have enough change",
    merchant: 'order.return_reason.360',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.driver_did_not_change',
    },
  },
  '361': {
    admin: 'Order placed, Food ready - driver did not pickup',
    merchant: 'order.return_reason.361',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.driver_did_not_pickup',
    },
  },
  '362': {
    admin: 'Driver is different from the app',
    merchant: 'order.return_reason.362',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.driver_different_from_app',
    },
  },
  '363': {
    admin: 'Switched order due to stacking',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.switched_order_due_to_stacking',
    }
  },
  '401': {
    admin: 'Food Bad Quality Issue',
    merchant: 'order.return_reason.401',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.bad_quality',
      index: 9,
    },
  },
  '402': {
    admin: 'Not following instruction',
    merchant: 'order.return_reason.402',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.not_instruction',
      index: 7,
    },
  },
  '403': {
    admin: 'Food Poisoning',
    merchant: 'order.return_reason.403',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.food_poisoning',
      index: 8,
    },
  },
  '404': {
    admin: 'Wrong / Missing Items',
    merchant: 'order.return_reason.404',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.wrong_items',
      index: 3,
    },
  },
  '405': {
    admin: 'Food Allergy',
    merchant: 'order.return_reason.405',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.food_allergy',
      index: 10,
    },
  },
  '406': {
    admin: 'Food temperature',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.food_temperature',
      index: 0,
    },
  },
  '407': {
    admin: 'Some ingredients missing',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.ingredients_missing',
      index: 6,
    },
  },
  '408': {
    admin: 'Item missing',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.item_missing',
      index: 5,
    },
  },
  '451': {
    admin: 'App Crash / not responding',
    merchant: 'order.return_reason.451',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.crash_not_responding',
    },
  },
  '452': {
    admin: 'Suspicious COD order',
    merchant: 'order.return_reason.452',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.suspicious_cod_order',
    },
  },
  '453': {
    admin: 'Hard Complaint',
    merchant: 'order.return_reason.453',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.hard_complaint',
    },
  },
  '454': {
    admin: 'Order price changed',
    merchant: 'order.return_reason.454',
    buyer: {
      enable: false,
      key: 'refund_detail.refund_reason.order_price_changed',
    },
  },
  '455': {
    admin: 'Pickup order was auto-completed but customer did not get the order',
    merchant: 'order.return_reason.455',
    buyer: {
      enable: true,
      key: 'refund_detail.refund_reason.not_get_order',
    },
  },
};

/**
 * @description KYC request reject reason
 * @description 1-200 => id; 201-400 => th; 401-600 => my;
 * @params category text
 * @link https://confluence.shopee.io/display/SPFOODY/5.3.2.3+Driver+System
 */

const faceVerification = 'Face Verification';
const attribute = 'Attribute';

// 2023/10/18 这里不太理解为什么从101开始, 似乎也并不是为了保证和 kycRequestReason 字段的键唯一性
// (参考 kycRequestReason 中也有 201 开始的键, 也就是键并不唯一
// 不过这里经手的同学比较多，而且大部分都离职了，现在也很难溯源
// 可能一开始确实是想保证键唯一性，但是后来发现不需要了，但是没有去掉
// 后续接手的同学，如果你有同样的疑惑，希望我这段注释可以帮到你
export const selfieKycRejectReason = {
  101: {
    admin: {
      category: faceVerification,
      text: 'Wrong Gender/Wrong Person',
    },
  },
  102: {
    admin: {
      category: faceVerification,
      text: 'Covered Face',
    },
  },
  103: {
    admin: {
      category: faceVerification,
      text: 'Wrong Picture',
    },
  },
  104: {
    admin: {
      category: faceVerification,
      text: 'Inappropriate Picture',
    },
  },
  105: {
    admin: {
      category: faceVerification,
      text: 'Photo Blur',
    },
  },
  106: {
    admin: {
      category: faceVerification,
      text: 'Change Appearance',
    },
  },
  201: {
    admin: {
      category: attribute,
      text: 'No Jacket',
    },
  },
  202: {
    admin: {
      category: attribute,
      text: 'Competitor Jacket',
    },
  },
  203: {
    admin: {
      category: attribute,
      text: 'Wrong Picture',
    },
  },
  204: {
    admin: {
      category: attribute,
      text: 'Inappropriate Picture',
    },
  },
  205: {
    admin: {
      category: attribute,
      text: 'Photo Blur',
    },
  },
  206: {
    admin: {
      category: attribute,
      text: 'Head Only',
    },
  },
  207: {
    admin: {
      category: attribute,
      text: 'Body Only',
    },
  },
  208: {
    admin: {
      category: attribute,
      text: 'Unofficial Jacket',
    },
  },
  209: {
    admin: {
      category: attribute,
      text: 'Improper Wearing',
    },
  },
};

export const photoVerificationReason = {
  // 1-200 是 id
  '1': {
    admin: {
      category: 'Profile Picture',
      text: 'Foto Profil Terlalu Dekat'
    },
    onboarding: {
      category: 'Profile Picture',
      text: 'Foto Profil Terlalu Dekat'
    }
  },
  '2': {
    admin: {
      category: 'Profile Picture',
      text: 'Background Foto Profil Tidak Polos'
    },
    onboarding: {
      category: 'Profile Picture',
      text: 'Background Foto Profil Tidak Polos'
    }
  },
  '3': {
    admin: {
      category: 'Profile Picture',
      text: 'Foto Profil Tidak Mengenakan Jaket Resmi ShopeeFood',
    },
    onboarding: {
      category: 'Profile Picture',
      text: 'Foto Profil Tidak Mengenakan Jaket Resmi ShopeeFood',
    }
  },
  '4': {
    admin: {
      category: 'Profile Picture',
      text: 'Bagian Wajah Foto Profil Terhalang/Tertutup'
    },
    onboarding: {
      category: 'Profile Picture',
      text: 'Bagian Wajah Foto Profil Terhalang/Tertutup'
    }
  },
  '5': {
    admin: { category: 'Others', text: 'Others' },
    foms: { category: 'Others', text: 'Others' },
  },

  // 201-400 是 th
  // Order ID / หมายเลขคำสั่งซื้อ
  '201': {
    admin: {
      category:'หมายเลขคำสั่งซื้อ',
      text: 'ไม่ได้ซื้อจากร้านออฟฟิเชียล หรือ ไม่พบหมายเลขคำสั่งซื้อเสื้อ'
    },
    onboarding: {
      category:'หมายเลขคำสั่งซื้อ',
      text: 'ไม่ได้ซื้อจากร้านออฟฟิเชียล หรือ ไม่พบหมายเลขคำสั่งซื้อเสื้อ'
    },
  },
  '202': {
    admin: {
      category:'หมายเลขคำสั่งซื้อ',
      text: 'หมายเลขคำสั่งซื้อถูกยกเลิก หรือ ไม่พบหมายเลขคำสั่งซื้ออุปกรณ์ '
    },
    onboarding: {
      category:'หมายเลขคำสั่งซื้อ',
      text: 'หมายเลขคำสั่งซื้อถูกยกเลิก หรือ ไม่พบหมายเลขคำสั่งซื้ออุปกรณ์ '
    },
  },
  // Profile Picture / รูปโปรไฟล์ไรเดอร์
  '203': {
    admin: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'รูปโปรไฟล์ไรเดอร์ไม่ชัดเจน',
    },
    onboarding: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'รูปโปรไฟล์ไรเดอร์ไม่ชัดเจน',
    },
  },
  '204': {
    admin: { category: 'รูปโปรไฟล์ไรเดอร์', text: 'สวมใส่แมสก์ขณะถ่ายรูป' },
    onboarding: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'สวมใส่แมสก์ขณะถ่ายรูป',
    },
  },
  '205': {
    admin: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'สวมใส่แว่นกันแดดขณะถ่ายรูป',
    },
    onboarding: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'สวมใส่แว่นกันแดดขณะถ่ายรูป',
    },
  },
  '206': {
    admin: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'ไม่สวมใส่เสื้อ ShopeeFood ขณะถ่ายรูป',
    },
    onboarding: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'ไม่สวมใส่เสื้อ ShopeeFood ขณะถ่ายรูป',
    },
  },
  '207': {
    admin: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'ไม่พบคะแนนแบบทดสอบ',
    },
    onboarding: {
      category: 'รูปโปรไฟล์ไรเดอร์',
      text: 'ไม่พบคะแนนแบบทดสอบ',
    },
  },
}


export const kycRejectReason = {
  // KTP
  '1': {
    admin: { category: 'KTP', text: 'KTP Tidak Terbaca/Blur/Rusak' },
    foms: { category: 'KTP', text: 'KTP Tidak Terbaca/Blur/Rusak' },
  },
  '2': {
    admin: { category: 'KTP', text: 'KTP Expired' },
    foms: { category: 'KTP', text: 'KTP Expired' },
  },
  '3': {
    admin: { category: 'KTP', text: 'KTP Terindikasi Edit/Palsu' },
    foms: { category: 'KTP', text: 'KTP Terindikasi Edit/Palsu' },
  },
  '4': {
    admin: { category: 'KTP', text: 'KTP Tidak Sesuai Format' },
    foms: { category: 'KTP', text: 'KTP Tidak Sesuai Format' },
  },
  '5': {
    admin: {category: 'KTP', text: 'KTP Scan/Fotokopi'},
    foms: {category: 'KTP', text: 'KTP Scan/Fotokopi'},
  },
  '6': {
    admin: {category: 'KTP', text: 'Penulisan Nama/NIK Tidak Sesuai KTP'},
    foms: {category: 'KTP', text: 'Penulisan Nama/NIK Tidak Sesuai KTP'},
  },
  // SIM
  '10': {
    admin: { category: 'SIM', text: 'SIM Tidak Terbaca/Blur/Rusak' },
    foms: { category: 'SIM', text: 'SIM Tidak Terbaca/Blur/Rusak' },
  },
  '11': {
    admin: { category: 'SIM', text: 'SIM Expired' },
    foms: { category: 'SIM', text: 'SIM Expired' },
  },
  '12': {
    admin: { category: 'SIM', text: 'SIM Terindikasi Edit/Palsu' },
    foms: { category: 'SIM', text: 'SIM Terindikasi Edit/Palsu' },
  },
  '13': {
    admin: { category: 'SIM', text: 'SIM Tidak Sesuai Format' },
    foms: { category: 'SIM', text: 'SIM Tidak Sesuai Format' },
  },
  '14': {
    admin: { category: 'SIM', text: 'SIM Scan/Fotokopi'},
    foms: { category: 'SIM', text: 'SIM Scan/Fotokopi'},
  },
  '15': {
    admin: { category: 'SIM', text: 'SIM Bukan Atas Nama Calon Driver'},
    foms: { category: 'SIM', text: 'SIM Bukan Atas Nama Calon Driver'},
  },
  '16': {
    admin: { category: 'SIM', text: 'Penulisan Nomor SIM Tidak Sesuai Dokumen'},
    foms: { category: 'SIM', text: 'Penulisan Nomor SIM Tidak Sesuai Dokumen'},
  },
  '17': {
    admin: { category: 'SIM', text: 'Penulisan Masa Berlaku SIM Tidak Sesuai Dokumen'},
    foms: { category: 'SIM', text: 'Penulisan Masa Berlaku SIM Tidak Sesuai Dokumen'},
  },
  // Bukti Rekening
  '20': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Tidak Terbaca/Blur/Rusak',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Tidak Terbaca/Blur/Rusak',
    },
  },
  '21': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Terindikasi Edit/Palsu',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Terindikasi Edit/Palsu',
    },
  },
  '22': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Tidak Sesuai Format',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Tidak Sesuai Format',
    },
  },
  '23': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Scan/Fotokopi',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Scan/Fotokopi',
    },
  },
  '24': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Bukan Atas Nama Calon Driver',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Bukti Rekening Bukan Atas Nama Calon Driver',
    },
  },
  '25': {
    admin: {
      category: 'Bukti Rekening',
      text: ' Penulisan Nama Rekening Tidak Sesuai Dokumen',
    },
    foms: {
      category: 'Bukti Rekening',
      text: ' Penulisan Nama Rekening Tidak Sesuai Dokumen',
    }
  },
  '26': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Penulisan Nomor Rekening Tidak Sesuai Dokumen',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Penulisan Nomor Rekening Tidak Sesuai Dokumen',
    }
  },
  '27': {
    admin: {
      category: 'Bukti Rekening',
      text: 'Penulisan Nama Bank Tidak Sesuai Dokumen',
    },
    foms: {
      category: 'Bukti Rekening',
      text: 'Penulisan Nama Bank Tidak Sesuai Dokumen',
    }
  },
  // Selfie / Selfie with KTP
  '30': {
    admin: { category: 'Selfie', text: 'Selfie with KTP Tidak Jelas' },
    foms: { category: 'Selfie', text: 'Selfie with KTP Tidak Jelas' },
  },
  '31': {
    admin: {
      category: 'Selfie',
      text: 'Selfie with KTP Tidak Sesuai Format',
    },
    foms: {
      category: 'Selfie',
      text: 'Selfie with KTP Tidak Sesuai Format',
    },
  },
  '32': {
    admin: {
      category: 'Selfie',
      text: 'Bagian Wajah Terhalang/Tertutup',
    },
    foms: {
      category: 'Selfie',
      text: 'Bagian Wajah Terhalang/Tertutup',
    },
  },
  // Agreement
  '40': {
    admin: { category: 'Agreement', text: 'Agreement Tidak Terbaca/Blur' },
    foms: { category: 'Agreement', text: 'Agreement Tidak Terbaca/Blur' },
  },
  '41': {
    admin: { category: 'Agreement', text: 'Agreement Tidak Sesuai Format' },
    foms: { category: 'Agreement', text: 'Agreement Tidak Sesuai Format' },
  },
  // SKCK / Police Certificate
  '50': {
    admin: { category: 'SKCK', text: 'SKCK Tidak Terbaca/Blur/Rusak' },
    foms: { category: 'SKCK', text: 'SKCK Tidak Terbaca/Blur/Rusak' },
  },
  '51': {
    admin: { category: 'SKCK', text: 'SKCK Expired' },
    foms: { category: 'SKCK', text: 'SKCK Expired' },
  },
  '52': {
    admin: { category: 'SKCK', text: 'SKCK Terindikasi Edit/Palsu' },
    foms: { category: 'SKCK', text: 'SKCK Terindikasi Edit/Palsu' },
  },
  '53': {
    admin: { category: 'SKCK', text: 'SKCK Tidak Sesuai Format' },
    foms: { category: 'SKCK', text: 'SKCK Tidak Sesuai Format' },
  },
  // Surat Izin Orang Tua / Parent PermitNomor Pokok Wajib Pajak (NPWP)
  '60': {
    admin: {
      category: 'Surat Izin Orang Tua',
      text: 'Surat Izin Orang Tua Tidak Terbaca/Blur/Rusak',
    },
    foms: {
      category: 'Surat Izin Orang Tua',
      text: 'Surat Izin Orang Tua Tidak Terbaca/Blur/Rusak',
    },
  },
  '61': {
    admin: {
      category: 'Surat Izin Orang Tua',
      text: 'Surat Izin Orang Tua tidak Sesuai Format',
    },
    foms: {
      category: 'Surat Izin Orang Tua',
      text: 'Surat Izin Orang Tua tidak Sesuai Format',
    },
  },
  '70': {
    admin: {
      category: 'ShopeePay Inquiry',
      text: 'Foto identitas kurang jelas',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text: 'Foto identitas kurang jelas',
    },
  },
  '71': {
    admin: {
      category: 'ShopeePay Inquiry',
      text:
        'Nomor/Nama yang dimasukkan tidak sama dengan yang tertulis di kartu identitas',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text:
        'Nomor/Nama yang dimasukkan tidak sama dengan yang tertulis di kartu identitas',
    },
  },
  '72': {
    admin: {
      category: 'ShopeePay Inquiry',
      text:
        'Detail rincian tertentu (selain nomor/nama kartu identitas) tidak sama dengan yang tertulis di kartu identitas',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text:
        'Detail rincian tertentu (selain nomor/nama kartu identitas) tidak sama dengan yang tertulis di kartu identitas',
    },
  },
  '73': {
    admin: {
      category: 'ShopeePay Inquiry',
      text: 'Foto tidak sesuai dengan contoh yang diberikan',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text: 'Foto tidak sesuai dengan contoh yang diberikan',
    },
  },
  '74': {
    admin: {
      category: 'ShopeePay Inquiry',
      text:
        'Tolong gunakan KTP/KITAS untuk verifikasi identitas SIM atau passport tidak diijinkan',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text:
        'Tolong gunakan KTP/KITAS untuk verifikasi identitas SIM atau passport tidak diijinkan',
    },
  },
  '75': {
    admin: {
      category: 'ShopeePay Inquiry',
      text: 'Nomor identitas sudah digunakan di terlalu banyak akun',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text: 'Nomor identitas sudah digunakan di terlalu banyak akun',
    },
  },
  '76': {
    admin: {
      category: 'ShopeePay Inquiry',
      text: 'Aplikasi yang diajukan belum dapat diterima',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text: 'Aplikasi yang diajukan belum dapat diterima',
    },
  },
  '77': {
    admin: {
      category: 'ShopeePay Inquiry',
      text: 'Aplikasi yang sudah diajukan ditolak dengan alasan keamanan',
    },
    foms: {
      category: 'ShopeePay Inquiry',
      text: 'Aplikasi yang sudah diajukan ditolak dengan alasan keamanan',
    },
  },
  // STNK
  '80': {
    admin: { category: 'STNK', text: 'STNK Tidak Terbaca/Blur/Rusak' },
    foms: { category: 'STNK', text: 'STNK Tidak Terbaca/Blur/Rusak' },
  },
  '81': {
    admin: { category: 'STNK', text: 'STNK Expired' },
    foms: { category: 'STNK', text: 'STNK Expired' },
  },
  '82': {
    admin: { category: 'STNK', text: 'STNK Terindikasi Edit/Palsu' },
    foms: { category: 'STNK', text: 'STNK Terindikasi Edit/Palsu' },
  },
  '83': {
    admin: { category: 'STNK', text: 'STNK Tidak Sesuai Format' },
    foms: { category: 'STNK', text: 'STNK Tidak Sesuai Format' },
  },
  '84': {
    admin: { category: 'STNK', text: 'Usia Kendaraan Tidak Sesuai' },
    foms: { category: 'STNK', text: 'Usia Kendaraan Tidak Sesuai' },
  },
  '85': {
    admin: { category: 'STNK', text: 'STNK Scan/Fotokopi'},
    foms: { category: 'STNK', text: 'STNK Scan/Fotokopi'},
  },
  '86': {
    admin: { category: 'STNK', text: 'Penulisan Tahun Pembuatan Kendaraan Tidak Sesuai Dokumen' },
    foms: { category: 'STNK', text: 'Penulisan Tahun Pembuatan Kendaraan Tidak Sesuai Dokumen' },
  },
  '87': {
    admin: { category: 'STNK', text: 'Penulisan Plat Nomor Tidak Sesuai Dokumen' },
    foms: { category: 'STNK', text: 'Penulisan Plat Nomor Tidak Sesuai Dokumen' },
  },
  '100': {
    admin: { category: 'Others', text: 'Others' },
    foms: { category: 'Others', text: 'Others' },
  },
  // Nomor Pokok Wajib Pajak (NPWP) / Taxpayer Identification Card
  '110': {
    admin: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Tidak Terbaca/Blur/Rusak'
    },
    foms: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Tidak Terbaca/Blur/Rusak'
    }
  },
  '111': {
    admin: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Terindikasi Edit/Palsu'
    },
    foms: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Terindikasi Edit/Palsu'
    }
  },
  '112': {
    admin: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Tidak Sesuai Format'
    },
    foms: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Tidak Sesuai Format'
    }
  },
  '113': {
    admin: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Scan/Fotokopi'
    },
    foms: {
      category: 'Nomor Pokok Wajib Pajak (NPWP)',
      text: 'NPWP Scan/Fotokopi'
    }
  },
  // Kartu Keluarga / Family Register
  '120': {
    admin: {
      category: 'Kartu Keluarga',
      text: 'KK Tidak Terbaca/Blur/Rusak'
    },
    foms: {
      category: 'Kartu Keluarga',
      text: 'KK Tidak Terbaca/Blur/Rusak'
    }
  },
  '121': {
    admin: {
      category: 'Kartu Keluarga',
      text: 'KK Scan/Fotokopi'
    },
    foms: {
      category: 'Kartu Keluarga',
      text: 'KK Scan/Fotokopi'
    }
  },


  '201': {
    admin: { category: 'ข้อมูลพื้นฐาน', text: 'กรอกข้อมูลอีเมลล์ ไม่ถูกต้อง' },
    onboarding: {
      category: 'ข้อมูลพื้นฐาน',
      text: 'กรอกข้อมูลอีเมลล์ ไม่ถูกต้อง',
    },
  },

  // ID Card (front) / บัตรประชาชน (ด้านหน้า)
  '207': {
    admin: {
      category: 'บัตรประชาชน (ด้านหน้า)',
      text: 'รูปภาพบัตรประชาชน (ด้านหน้า)ไม่ชัดเจน',
    },
    onboarding: {
      category: 'บัตรประชาชน (ด้านหน้า)',
      text: 'รูปภาพบัตรประชาชน (ด้านหน้า)ไม่ชัดเจน',
    },
  },
  '208': {
    admin: {
      category: 'บัตรประชาชน (ด้านหน้า)',
      text: 'บัตรประชาชนหมดอายุ',
    },
    onboarding: {
      category: 'บัตรประชาชน (ด้านหน้า)',
      text: 'บัตรประชาชนหมดอายุ',
    },
  },
  '209': {
    admin: {
      category: 'บัตรประชาชน (ด้านหน้า)',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนบัตรประชาชน',
    },
    onboarding: {
      category: 'บัตรประชาชน (ด้านหน้า)',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนบัตรประชาชน',
    },
  },
  //  ID Card (back) / บัตรประชาชน (ด้านหลัง)
  '210': {
    admin: {
      category: 'บัตรประชาชน (ด้านหลัง)',
      text: 'รูปภาพบัตรประชาชน (ด้านหลัง)ไม่ชัดเจน',
    },
    onboarding: {
      category: 'บัตรประชาชน (ด้านหลัง)',
      text: 'รูปภาพบัตรประชาชน (ด้านหลัง)ไม่ชัดเจน',
    },
  },
  '211': {
    admin: {
      category: 'บัตรประชาชน (ด้านหลัง)',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนบัตรประชาชน',
    },
    onboarding: {
      category: 'บัตรประชาชน (ด้านหลัง)',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนบัตรประชาชน',
    },
  },
  // Driving License / ใบขับขี่
  '212': {
    admin: { category: 'ใบขับขี่', text: 'รูปภาพใบขับขี่ไม่ชัดเจน' },
    onboarding: { category: 'ใบขับขี่', text: 'รูปภาพใบขับขี่ไม่ชัดเจน' },
  },
  '213': {
    admin: { category: 'ใบขับขี่', text: 'ใบขับขี่หมดอายุ' },
    onboarding: { category: 'ใบขับขี่', text: 'ใบขับขี่หมดอายุ' },
  },
  '214': {
    admin: { category: 'ใบขับขี่', text: 'ไม่ใช่ใบขับขี่รถจักรยานยนต์' },
    onboarding: { category: 'ใบขับขี่', text: 'ไม่ใช่ใบขับขี่รถจักรยานยนต์' },
  },
  '215': {
    admin: {
      category: 'ใบขับขี่',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนใบขับขี่',
    },
    onboarding: {
      category: 'ใบขับขี่',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนใบขับขี่',
    },
  },
  // Vehicle Insurance / พ.ร.บ. รถจักรยานยนต์
  '216': {
    admin: { category: 'พ.ร.บ. รถจักรยานยนต์', text: 'รูปภาพพ.ร.บ.ไม่ชัดเจน' },
    onboarding: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'รูปภาพพ.ร.บ.ไม่ชัดเจน',
    },
  },
  '217': {
    admin: { category: 'พ.ร.บ. รถจักรยานยนต์', text: 'พ.ร.บ.หมดอายุ' },
    onboarding: { category: 'พ.ร.บ. รถจักรยานยนต์', text: 'พ.ร.บ.หมดอายุ' },
  },
  '218': {
    admin: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'เอกสาร พ.ร.บ.ไม่ถูกต้อง',
    },
    onboarding: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'เอกสาร พ.ร.บ.ไม่ถูกต้อง',
    },
  },
  '219': {
    admin: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'เอกสาร พ.ร.บ.เป็นรถคนละคันกับในเอกสารสำเนาเล่มทะเบียนรถ',
    },
    onboarding: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'เอกสาร พ.ร.บ.เป็นรถคนละคันกับในเอกสารสำเนาเล่มทะเบียนรถ',
    },
  },
  '220': {
    admin: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนพ.ร.บ.',
    },
    onboarding: {
      category: 'พ.ร.บ. รถจักรยานยนต์',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนพ.ร.บ.',
    },
  },
  // Vehicle Certificate / คู่มือจดทะเบียนรถ
  '221': {
    admin: {
      category: 'คู่มือจดทะเบียนรถ',
      text: 'รูปภาพคู่มือจดทะเบียนรถไม่ชัดเจน',
    },
    onboarding: {
      category: 'คู่มือจดทะเบียนรถ',
      text: 'รูปภาพคู่มือจดทะเบียนรถไม่ชัดเจน',
    },
  },
  '222': {
    admin: {
      category: 'คู่มือจดทะเบียนรถ',
      text: 'เอกสารคู่มือจดทะเบียนรถไม่ถูกต้อง',
    },
    onboarding: {
      category: 'คู่มือจดทะเบียนรถ',
      text: 'เอกสารคู่มือจดทะเบียนรถไม่ถูกต้อง',
    },
  },
  '223': {
    admin: {
      category: 'คู่มือจดทะเบียนรถ',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนคู่มือจดทะเบียนรถ',
    },
    onboarding: {
      category: 'คู่มือจดทะเบียนรถ',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนคู่มือจดทะเบียนรถ',
    },
  },
  // Bank account / บัญชีธนาคาร
  '224': {
    admin: { category: 'บัญชีธนาคาร', text: 'รูปภาพสมุดบัญชีไม่ชัดเจน' },
    onboarding: { category: 'บัญชีธนาคาร', text: 'รูปภาพสมุดบัญชีไม่ชัดเจน' },
  },
  '225': {
    admin: { category: 'บัญชีธนาคาร', text: 'เอกสารสมุดบัญชีไม่ถูกต้อง' },
    onboarding: { category: 'บัญชีธนาคาร', text: 'เอกสารสมุดบัญชีไม่ถูกต้อง' },
  },
  '226': {
    admin: {
      category: 'บัญชีธนาคาร',
      text: 'ชื่อบัญชี ไม่ตรงกับชื่อในบัตรประชาชน',
    },
    onboarding: {
      category: 'บัญชีธนาคาร',
      text: 'ชื่อบัญชี ไม่ตรงกับชื่อในบัตรประชาชน',
    },
  },
  '227': {
    admin: {
      category: 'บัญชีธนาคาร',
      text: 'เลขที่บัญชี ไม่สามารถทำธุรกรรมได้',
    },
    onboarding: {
      category: 'บัญชีธนาคาร',
      text: 'เลขที่บัญชี ไม่สามารถทำธุรกรรมได้',
    },
  },
  '228': {
    admin: {
      category: 'บัญชีธนาคาร',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนรูปภาพสมุดบัญชี',
    },
    onboarding: {
      category: 'บัญชีธนาคาร',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนรูปภาพสมุดบัญชี',
    },
  },
  // Emergency contact number / ผู้ติดต่อกรณีฉุกเฉิน
  '229': {
    admin: {
      category: 'ผู้ติดต่อกรณีฉุกเฉิน',
      text: 'เบอร์ผู้ติดต่อกรณีฉุกเฉินไม่ถูกต้อง',
    },
    onboarding: {
      category: 'ผู้ติดต่อกรณีฉุกเฉิน',
      text: 'เบอร์ผู้ติดต่อกรณีฉุกเฉินไม่ถูกต้อง',
    },
  },
  '230': {
    admin: {
      category: 'ผู้ติดต่อกรณีฉุกเฉิน',
      text: 'ชื่อผู้ติดต่อกรณีฉุกเฉินไม่ถูกต้อง',
    },
    onboarding: {
      category: 'ผู้ติดต่อกรณีฉุกเฉิน',
      text: 'ชื่อผู้ติดต่อกรณีฉุกเฉินไม่ถูกต้อง',
    },
  },
  '231': {
    admin: {
      category: 'ผู้ติดต่อกรณีฉุกเฉิน',
      text: 'ความสัมพันธ์ผู้ติดต่อกรณีฉุกเฉินไม่ถูกต้อง',
    },
    onboarding: {
      category: 'ผู้ติดต่อกรณีฉุกเฉิน',
      text: 'ความสัมพันธ์ผู้ติดต่อกรณีฉุกเฉินไม่ถูกต้อง',
    },
  },
  // Copy ID Card of owner vehicle / สำเนาบัตรประชาชนของเจ้าของรถ
  '232': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'รูปภาพสำเนาบัตรประชาชนของเจ้าของรถไม่ชัดเจน',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'รูปภาพสำเนาบัตรประชาชนของเจ้าของรถไม่ชัดเจน',
    },
  },
  '233': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'บัตรประชาชนของเจ้าของรถหมดอายุ',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'บัตรประชาชนของเจ้าของรถหมดอายุ',
    },
  },
  '234': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนสำเนาบัตรประชาชนของเจ้าของรถ',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนสำเนาบัตรประชาชนของเจ้าของรถ',
    },
  },
  '235': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text:
        'ไม่ได้ระบุ “ยินยอมให้ชื่อผู้สมัครใช้รถ เพื่อขับ ShopeeFood” บนสำเนาบัตรประชาชนของเจ้าของรถ',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text:
        'ไม่ได้ระบุ “ยินยอมให้ชื่อผู้สมัครใช้รถ เพื่อขับ ShopeeFood” บนสำเนาบัตรประชาชนของเจ้าของรถ',
    },
  },
  '236': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'ชื่อไม่ตรงกับในเอกสารเล่มทะเบียน',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'ชื่อไม่ตรงกับในเอกสารเล่มทะเบียน',
    },
  },

  '237': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'เอกสารสำเนาบัตรประชาชนของเจ้าของรถไม่ถูกต้อง',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'เอกสารสำเนาบัตรประชาชนของเจ้าของรถไม่ถูกต้อง',
    },
  },

  // Parent consent form (Age 16-19) / เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)
  '238': {
    admin: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'รูปภาพเอกสารยินยอมจากผู้ปกครองไม่ชัดเจน',
    },
    onboarding: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'รูปภาพเอกสารยินยอมจากผู้ปกครองไม่ชัดเจน',
    },
  },
  '239': {
    admin: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'เอกสารยินยอมจากผู้ปกครองไม่ถูกต้อง',
    },
    onboarding: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'เอกสารยินยอมจากผู้ปกครองไม่ถูกต้อง',
    },
  },
  '240': {
    admin: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'ข้อมูลไม่ตรงกับสำเนาบัตรประชาชนของผู้ปกครอง',
    },
    onboarding: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'ข้อมูลไม่ตรงกับสำเนาบัตรประชาชนของผู้ปกครอง',
    },
  },
  '241': {
    admin: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'กรอกข้อมูลในเอกสารยินยอมจากผู้ปกครองไม่ครบถ้วน',
    },
    onboarding: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'กรอกข้อมูลในเอกสารยินยอมจากผู้ปกครองไม่ครบถ้วน',
    },
  },
  // สำเนาบัตรประชาชนของผู้ปกครอง
  '242': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'รูปภาพสำเนาบัตรประชาชนของผู้ปกครองไม่ชัดเจน',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'รูปภาพสำเนาบัตรประชาชนของผู้ปกครองไม่ชัดเจน',
    },
  },
  '243': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'บัตรประชาชนของผู้ปกครองหมดอายุ',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'บัตรประชาชนของผู้ปกครองหมดอายุ',
    },
  },
  '244': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนสำเนาบัตรประชาชนของผู้ปกครอง',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'ไม่เซ็นรับรองสำเนาถูกต้องบนสำเนาบัตรประชาชนของผู้ปกครอง',
    },
  },
  '245': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text:
        'ไม่ได้ระบุ “ยินยอมให้สมัครเข้าร่วมเป็นพาร์ทเนอร์ผู้ขับขี่ ShopeeFood”บนสำเนาบัตรประชาชนของผู้ปกครอง',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text:
        'ไม่ได้ระบุ “ยินยอมให้สมัครเข้าร่วมเป็นพาร์ทเนอร์ผู้ขับขี่ ShopeeFood”บนสำเนาบัตรประชาชนของผู้ปกครอง',
    },
  },
  '246': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'ข้อมูลไม่ตรงกับเอกสารยินยอมจากผู้ปกครอง',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'ข้อมูลไม่ตรงกับเอกสารยินยอมจากผู้ปกครอง',
    },
  },
  '247': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'เอกสารสำเนาบัตรประชาชนของผู้ปกครองไม่ถูกต้อง',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'เอกสารสำเนาบัตรประชาชนของผู้ปกครองไม่ถูกต้อง',
    },
  },
  // Name change certificate / เอกสารการเปลี่ยนชื่อ
  '248': {
    admin: { category: 'เอกสารการเปลี่ยนชื่อ', text: 'ใบเปลี่ยนชื่อไม่ชัดเจน' },
    onboarding: {
      category: 'เอกสารการเปลี่ยนชื่อ',
      text: 'ใบเปลี่ยนชื่อไม่ชัดเจน',
    },
  },
  '249': {
    admin: {
      category: 'เอกสารการเปลี่ยนชื่อ',
      text: 'เอกสารการเปลี่ยนชื่อไม่ถูกต้อง',
    },
    onboarding: {
      category: 'เอกสารการเปลี่ยนชื่อ',
      text: 'เอกสารการเปลี่ยนชื่อไม่ถูกต้อง',
    },
  },
  // Last name change certificate / เอกสารการเปลี่ยนชื่อสกุล
  '250': {
    admin: {
      category: 'เอกสารการเปลี่ยนชื่อสกุล',
      text: 'ใบเปลี่ยนชื่อสกุลไม่ชัดเจน',
    },
    onboarding: {
      category: 'เอกสารการเปลี่ยนชื่อสกุล',
      text: 'ใบเปลี่ยนชื่อสกุลไม่ชัดเจน',
    },
  },
  '251': {
    admin: {
      category: 'เอกสารการเปลี่ยนชื่อสกุล',
      text: 'ใบเปลี่ยนชื่อสกุลไม่ถูกต้อง',
    },
    onboarding: {
      category: 'เอกสารการเปลี่ยนชื่อสกุล',
      text: 'ใบเปลี่ยนชื่อสกุลไม่ถูกต้อง',
    },
  },
  //  Leasing or Sales Agreement / สัญญาเช่าซื้อ หรือ ใบซื้อขายรถ
  '252': {
    admin: {
      category: 'สัญญาเช่าซื้อ หรือ ใบซื้อขายรถ',
      text: 'สัญญาเช่าซื้อ หรือ ใบซื้อขายรถไม่ชัดเจน',
    },
    onboarding: {
      category: 'สัญญาเช่าซื้อ หรือ ใบซื้อขายรถ',
      text: 'สัญญาเช่าซื้อ หรือ ใบซื้อขายรถไม่ชัดเจน',
    },
  },
  '253': {
    admin: {
      category: 'สัญญาเช่าซื้อ หรือ ใบซื้อขายรถ',
      text: 'ใบเปลี่ยนชื่อสกุลไม่ถูกต้อง',
    },
    onboarding: {
      category: 'สัญญาเช่าซื้อ หรือ ใบซื้อขายรถ',
      text: 'ใบเปลี่ยนชื่อสกุลไม่ถูกต้อง',
    },
  },
  // Criminal record form / ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์
  '254': {
    admin: {
      category: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์',
      text: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์ไม่ชัดเจน',
    },
    onboarding: {
      category: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์',
      text: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์ไม่ชัดเจน',
    },
  },
  '255': {
    admin: {
      category: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์',
      text: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์ไม่ถูกต้อง',
    },
    onboarding: {
      category: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์',
      text: 'ใบคดีถึงที่สุด หรือ ใบบริสุทธิ์ไม่ถูกต้อง',
    },
  },
  '256': {
    admin: {
      category: 'ข้อมูลพื้นฐาน',
      text: 'กรอกข้อมูลจังหวัดที่ปฎิบัติงาน ไม่ถูกต้อง',
    },
    onboarding: {
      category: 'ข้อมูลพื้นฐาน',
      text: 'กรอกข้อมูลจังหวัดที่ปฎิบัติงาน ไม่ถูกต้อง',
    },
  },
  '257': {
    admin: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'ไม่ได้แนบเอกสารสำเนาบัตรประชาชนของเจ้าของรถ',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของเจ้าของรถ',
      text: 'ไม่ได้แนบเอกสารสำเนาบัตรประชาชนของเจ้าของรถ',
    },
  },
  '258': {
    admin: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'ไม่ได้แนบเอกสารยินยอมจากผู้ปกครอง',
    },
    onboarding: {
      category: 'เอกสารยินยอมจากผู้ปกครอง (กรณีอายุ 16-19 ปี)',
      text: 'ไม่ได้แนบเอกสารยินยอมจากผู้ปกครอง',
    },
  },
  // Selfie with ID Card / รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน
  '260': {
     admin:{
       category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
       text: 'รูปถ่ายผู้สมัครกับบัตรประชาชนไม่ชัดเจน'
     },
      onboarding:{
  category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
    text: 'รูปถ่ายผู้สมัครกับบัตรประชาชนไม่ชัดเจน'
}
  },
  '261': {
    admin: {
      category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
      text: 'รูปถ่ายผู้สมัครไม่ได้ถือบัตรประชาชน'
    },
    onboarding: {
      category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
      text: 'รูปถ่ายผู้สมัครไม่ได้ถือบัตรประชาชน'
    }
  },
  '262': {
    admin: {
      category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
      text: 'ผู้สมัครถือบัตรประชาชนบดบังใบหน้า'
    },
    onboarding: {
      category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
      text: 'ผู้สมัครถือบัตรประชาชนบดบังใบหน้า'
    }
  },
  '263': {

    admin: {
      category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
      text: 'กรุณาสวมเสื้อขณะถ่ายรูปคู่บัตรประชาชน'
    },
    onboarding: {
      category: 'รูปถ่ายผู้สมัครถ่ายคู่บัตรประชาชน',
      text: 'กรุณาสวมเสื้อขณะถ่ายรูปคู่บัตรประชาชน'
    }
  },
  // สำเนาบัตรประชาชนของผู้ปกครอง part2
  '266': {
    admin: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'ไม่ได้แนบเอกสารสำเนาบัตรประชาชนของผู้ปกครอง',
    },
    onboarding: {
      category: 'สำเนาบัตรประชาชนของผู้ปกครอง',
      text: 'ไม่ได้แนบเอกสารสำเนาบัตรประชาชนของผู้ปกครอง',
    },
  },

  // SWAFOTO
  '401': {
    admin: { category: 'Swafoto', text: 'Swafoto yang kabur atau gelap' },
    onboarding: { category: 'Swafoto', text: 'Swafoto yang kabur atau gelap' },
  },
  '402': {
    admin: { category: 'Swafoto', text: 'Swafoto: memakai penutup muka' },
    onboarding: { category: 'Swafoto', text: 'Swafoto: memakai penutup muka' },
  },
  '403': {
    admin: { category: 'Swafoto', text: 'Swafoto: memakai cermin mata hitam' },
    onboarding: {
      category: 'Swafoto',
      text: 'Swafoto: memakai cermin mata hitam',
    },
  },
  '404': {
    admin: { category: 'Swafoto', text: 'Swafoto: menggunakan penapis foto (filter)' },
    onboarding: {
      category: 'Swafoto',
      text: 'Swafoto: menggunakan penapis foto (filter)',
    },
  },
  '405': {
    admin: { category: 'Swafoto', text: 'Swafoto kumpulan' },
    onboarding: { category: 'Swafoto', text: 'Swafoto kumpulan' },
  },
  // KAD PENGENALAN (DEPAN)
  '406': {
    admin: { category: 'Kad Pengenalan (Depan)', text: 'Kad pengenalan merah atau hijau' },
    onboarding: {
      category: 'Kad Pengenalan (Depan)',
      text: 'Kad pengenalan merah atau hijau',
    },
  },
  '407': {
    admin: {
      category: 'Kad Pengenalan (Depan)',
      text: 'Gambar IC kabur atau gelap',
    },
    onboarding: {
      category: 'Kad Pengenalan (Depan)',
      text: 'Gambar IC kabur atau gelap',
    },
  },
  '408': {
    admin: {
      category: 'Kad Pengenalan (Depan)',
      text: ' Belum mencapai umur 18 tahun pada tarikh hari ini',
    },
    onboarding: {
      category: 'Kad Pengenalan (Depan)',
      text: ' Belum mencapai umur 18 tahun pada tarikh hari ini',
    },
  },
  '409': {
    admin: { category: 'Kad Pengenalan (Depan)', text: 'Nombor kad pengenalan tidak jelas' },
    onboarding: {
      category: 'Nombor kad pengenalan tidak jelas',
      text: 'Nombor kad pengenalan tidak jelas',
    },
  },
  '410': {
    admin: {
      category: 'Kad Pengenalan (Depan)',
      text: 'Kad pengenalan fotostat',
    },
    onboarding: {
      category: 'Kad Pengenalan (Depan)',
      text: 'Kad pengenalan fotostat',
    },
  },
  // KAD PENGENALAN (BELAKANG
  '411': {
    admin: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Kad pengenalan merah atau hijau',
    },
    onboarding: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Kad pengenalan merah atau hijau',
    },
  },
  '412': {
    admin: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Gambar IC kabur atau gelap',
    },
    onboarding: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Gambar IC kabur atau gelap',
    },
  },
  '413': {
    admin: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Nombor kad pengenalan tidak jelas',
    },
    onboarding: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Nombor kad pengenalan tidak jelas',
    },
  },
  '415': {
    admin: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Kad pengenalan fotostat',
    },
    onboarding: {
      category: 'Kad Pengenalan (Belakang)',
      text: 'Kad pengenalan fotostat',
    },
  },
  // LESEN MOTOSIKAL
  '416': {
    admin: { category: 'lesen motosikal', text: 'Lesen tamat tempoh' },
    onboarding: { category: 'lesen motosikal', text: 'Lesen tamat tempoh' },
  },
  '417': {
    admin: { category: 'lesen motosikal', text: 'Gambar lesen yang kabur atau gelap' },
    onboarding: {
      category: 'lesen motosikal',
      text: 'Gambar lesen yang kabur atau gelap',
    },
  },
  '418': {
    admin: { category: 'lesen motosikal', text: 'Dokumen yang salah untuk lesen' },
    onboarding: {
      category: 'lesen motosikal',
      text: 'Dokumen yang salah untuk lesen',
    },
  },
  // CUKAI JALAN
  '419': {
    admin: { category: 'Cukai jalan', text: 'Cukai jalan tamat tempoh' },
    onboarding: { category: 'Cukai jalan', text: 'Cukai jalan tamat tempoh' },
  },
  '420': {
    admin: { category: 'Cukai jalan', text: 'Gambar cukai jalan yang kabur atau gelap' },
    onboarding: {
      category: 'Cukai jalan',
      text: 'Gambar cukai jalan yang kabur atau gelap',
    },
  },
  '421': {
    admin: {
      category: 'Cukai jalan',
      text: 'Dokumen yang salah untuk cukai jalan',
    },
    onboarding: {
      category: 'Cukai jalan',
      text: 'Dokumen yang salah untuk cukai jalan',
    },
  },
  '422': {
    admin: {
      category: 'Cukai jalan',
      text: 'Nombor plat di cukai jalan tidak sama dengan geran',
    },
    onboarding: {
      category: 'Cukai jalan',
      text: 'Nombor plat di cukai jalan tidak sama dengan geran',
    },
  },
  '423': {
    admin: {
      category: 'Cukai jalan',
      text: 'Cukai jalan hampir tamat tempoh – kurang dari 7 hari',
    },
    onboarding: {
      category: 'Cukai jalan',
      text: 'Cukai jalan hampir tamat tempoh – kurang dari 7 hari',
    },
  },
  // GERAN
  '424': {
    admin: { category: 'Geran', text: 'Gambar geran yang kabur atau gelap' },
    onboarding: { category: 'Geran', text: 'Gambar geran yang kabur atau gelap' },
  },
  '425': {
    admin: { category: 'Geran', text: 'Dokumen yang salah untuk geran' },
    onboarding: { category: 'Geran', text: 'Dokumen yang salah untuk geran' },
  },
  // 426 has been deleted
  '427': {
    admin: { category: 'Geran', text: 'Nombor plat di geran tidak sama dengan cukai jalan' },
    onboarding: { category: 'Geran', text: 'Nombor plat di geran tidak sama dengan cukai jalan' },
  },
  // AKAUN BANK
  '429': {
    admin: {
      category: 'Akaun bank',
      text: 'Nombor akaun tidak sama dengan penyata bank',
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Nombor akaun tidak sama dengan penyata bank',
    },
  },
  '430': {
    admin: { category: 'Akaun bank', text: 'Gambar penyata bank yang kabur' },
    onboarding: {
      category: 'Akaun bank',
      text: 'Gambar penyata bank yang kabur',
    },
  },
  // 431 has been deleted
  '432': {
    admin: {
      category: 'Akaun bank',
      text: 'Tiada nama bank dalam penyata bank',
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Tiada nama bank dalam penyata bank',
    },
  },
  '433': {
    admin: {
      category: 'Akaun bank',
      text: 'Tiada nombor akaun dalam penyata bank',
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Tiada nombor akaun dalam penyata bank',
    },
  },
  '434': {
    admin: {
      category: 'Akaun bank',
      text: 'Tiada nama pemohon dalam penyata bank',
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Tiada nama pemohon dalam penyata bank',
    },
  },
  // NOMBOR HUBUNGAN KECEMASAN
  '435': {
    admin: {
      category: 'Nombor hubungan kecemasan',
      text: 'Nombor kontak kecemasan yang tidak sah',
    },
    onboarding: {
      category: 'Nombor hubungan kecemasan',
      text: 'Nombor kontak kecemasan yang tidak sah',
    },
  },
  // UJIAN
  '436': {
    admin: { category: 'Ujian', text: 'Gagal latihan asas di Langkah 2' },
    onboarding: {
      category: 'Ujian',
      text: 'Gagal latihan asas di Langkah 2',
    },
  },
  '437': {
    admin: {
      category: 'Ujian',
      text: 'Gagal latihan pematuhan halal di Langkah 2',
    },
    onboarding: {
      category: 'Ujian',
      text: 'Gagal latihan pematuhan halal di Langkah 2',
    },
  },
  '438': {
    admin: {
      category: 'Ujian',
      text: 'Belum ambil latihan asas di Langkah 2',
    },
    onboarding: {
      category: 'Ujian',
      text: 'Belum ambil latihan asas di Langkah 2',
    },
  },
  '439': {
    admin: {
      category: 'Ujian',
      text: 'Belum ambil latihan pematuhan halal di Langkah 2',
    },
    onboarding: {
      category: 'Ujian',
      text: 'Belum ambil latihan pematuhan halal di Langkah 2',
    },
  },
  // LESEN MOTOSIKAL part2
  '440':{
    admin: { category: 'lesen motosikal', text: 'Lesen L' },
    onboarding: { category: 'lesen motosikal', text: 'Lesen L' },
  },
  '441':{
    admin: { category: 'lesen motosikal', text: 'Lesen D' },
    onboarding: { category: 'lesen motosikal', text: 'Lesen D' },
  },
  '442':{
    admin: { category: 'lesen motosikal', text: 'Lesen hampir tamat tempoh – kurang dari 7 hari' },
    onboarding: { category: 'lesen motosikal', text: 'Lesen hampir tamat tempoh – kurang dari 7 hari' },
  },
  // AKAUN BANK part2
  '443': {
    admin: {
      category: 'Akaun bank',
      text: 'Guna bank akaun orang lain',
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Guna bank akaun orang lain',
    }
  },
  '444': {
    admin: {
      category: 'Akaun bank',
      text: 'Kad bank tidak diterima'
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Kad bank tidak diterima'
    }
  },
  '445': {
    admin: {
      category: 'Akaun bank',
      text: 'Slip ATM tidak diterima'
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Slip ATM tidak diterima'
    }
  },
  '446': {
    admin: {
      category: 'Akaun bank',
      text: 'Dokumen yang salah untuk penyata bank'
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Dokumen yang salah untuk penyata bank'
    }
  },
  '447': {
    admin: {
      category: 'Akaun bank',
      text: 'Nama pemegang akaun tidak sama dengan IC pemohon'
    },
    onboarding: {
      category: 'Akaun bank',
      text: 'Nama pemegang akaun tidak sama dengan IC pemohon'
    }
  },
  // NOMBOR HUBUNGAN KECEMASAN part2
  '448': {
    admin: {
      category: 'Nombor hubungan kecemasan',
      text: 'Nama kontak kecemasan tidak sah',
    },
    onboarding: {
      category: 'Nombor hubungan kecemasan',
      text: 'Nama kontak kecemasan tidak sah',
    },
  },
  // Ujian Part2
  '449': {
    admin: {
      category: 'Ujian',
      text: 'Belum ambil latihan asas & latihan pematuhan halal di Langkah 2'
    },
    onboarding: {
      category: 'Ujian',
      text: 'Belum ambil latihan asas & latihan pematuhan halal di Langkah 2'
    }
  },
  // Swafoto part2
  '450': {
    admin: {
      category: 'Swafoto',
      text: 'Swafoto tidak berpakaian lengkap atau sopan',

    },
    onboarding: {
      category: 'Swafoto',
      text: 'Swafoto tidak berpakaian lengkap atau sopan',
    }
  },
  '451': {
    admin: {
      category: 'Swafoto',
      text: 'Swafoto memakai pakaian berlogo platform pesaing',

    },
    onboarding: {
      category: 'Swafoto',
      text: 'Swafoto memakai pakaian berlogo platform pesaing',
    }
  },
  '452': {
    admin: {
      category: 'Swafoto',
      text: 'Swafoto memakai topi',

    },
    onboarding: {
      category: 'Swafoto',
      text: 'Swafoto memakai topi',
    }
  }


};

export const returnRejectReason = {
  '1': {
    admin: 'Others',
    buyer: {
      key: 'order_detail.cancel_reason.others',
    },
  },
  '2': {
    admin:
      'Your refund request has been declined due to customer put wrong text address',
    buyer: {
      key: 'refund_detail.reject_reason.2',
    },
  },
  '3': {
    admin:
      'Your refund request has been declined due to insufficient information or evidence',
    buyer: {
      key: 'refund_detail.reject_reason.3',
    },
  },
  '4': {
    admin:
      'Your refund request has been declined due to driver takes too long but not over 45 minutes',
    buyer: {
      key: 'refund_detail.reject_reason.4',
    },
  },
  '5': {
    admin:
      'Your refund request has been declined due to the request was not submitted within 24 hours after the food has been delivered',
    buyer: {
      key: 'refund_detail.reject_reason.5',
    },
  },
  '6': {
    admin:
      'Your refund request has been declined due to your food condition is not eligible for a refund',
    buyer: {
      key: 'refund_detail.reject_reason.6',
    },
  },
  '7': {
    admin:
      'Your refund request has been declined due to complaints of food portion and taste are not included in our refund eligibility policy',
    buyer: {
      key: 'refund_detail.reject_reason.7',
    },
  },
  '8': {
    admin:
      'Your refund request has been declined due to customer change of mind is not included in our refund eligibility policy',
    buyer: {
      key: 'refund_detail.reject_reason.8',
    },
  },
  '9': {
    admin:
      'Your refund request has beeen declined due to damaged/defective food packaging did not effect the food quality',
    buyer: {
      key: 'refund_detail.reject_reason.9',
    },
  },
  '10': {
    admin:
      'Your refund request has been declined due to the submitted refund reason does not meet our refund eligibility policy',
    buyer: {
      key: 'refund_detail.reject_reason.10',
    },
  },
  '11': {
    admin:
      'Your request is being processed, the result will be notified back at Shopee notification page',
    buyer: {
      key: 'refund_detail.reject_reason.11',
    },
  },
};
